import React from 'react'
import ComingSoonPage from '../components/common/ComingSoonPage'

const Subscribe = () => {
  return (
    <div>
<ComingSoonPage />
    </div>
  )
}

export default Subscribe